import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const STRONG_RULES = [
    { name: 'Minimum Length: 12 characters', pattern: /.{12,}/ },
    { name: 'Uppercase letters (A-Z)', pattern: /[A-Z]/ },
    { name: 'Lowercase letters (a-z)', pattern: /[a-z]/ },
    { name: 'Numbers (0-9)', pattern: /[0-9]/ },
    { name: 'Special characters (@ # $ % ^ & * _ - + = ! ?)', pattern: /[@#$%^&*_\-+=!?]/ },
];
const FALLBACK_RULES = [
    { name: 'Minimum Length: 8 characters', pattern: /.{8,}/ },
];
const PasswordStrengthMeter = ({ password = '', strongPolicy = true, }) => {
    const validationRules = strongPolicy ? STRONG_RULES : FALLBACK_RULES;
    const strength = validationRules.reduce((acc, rule) => {
        return acc + (rule.pattern.test(password) ? 1 : 0);
    }, 0);
    const strengthPercentage = (strength / validationRules.length) * 100;
    const getStrengthColor = () => {
        if (strengthPercentage < 50)
            return 'bg-red-500';
        if (strengthPercentage < 80)
            return 'bg-orange-500';
        return 'bg-green-500';
    };
    const getStrengthLabel = () => {
        if (password.length === 0)
            return null;
        if (strengthPercentage < 50)
            return 'Weak';
        if (strengthPercentage < 80)
            return 'Moderate';
        return 'Strong';
    };
    const label = getStrengthLabel();
    return (_jsxs("div", { className: "password-policy-container mt-2", children: [_jsxs("div", { className: "flex items-center justify-between mb-1", children: [_jsx("span", { className: "text-xs text-gray-400", children: "Password strength" }), label && (_jsx("span", { className: `text-xs font-medium ${label === 'Weak' ? 'text-red-500' : label === 'Moderate' ? 'text-orange-500' : 'text-green-500'}`, children: label }))] }), _jsx("div", { className: "password-strength-meter h-2 bg-gray-200 rounded-full overflow-hidden mb-2", children: _jsx("div", { className: `h-full transition-all duration-300 ${getStrengthColor()}`, style: { width: `${strengthPercentage}%` } }) }), _jsx("ul", { className: "policy-checklist list-none p-0 m-0 text-sm", children: validationRules.map((rule, index) => (_jsxs("li", { className: `flex items-center mb-1 ${rule.pattern.test(password) ? 'text-green-500' : 'text-gray-400'}`, children: [_jsx("span", { className: "mr-2", children: rule.pattern.test(password) ? '✓' : '✗' }), rule.name] }, index))) })] }));
};
export default PasswordStrengthMeter;
